import { gql } from 'graphql-request';
import networkAdapter from '../adapters/network';
import { orchestrationLayerFetcher } from 'util/OL';
import { trackError } from 'util/error';

export const fetchAllOwnedFields = ({ userId }) => {
  const legacyOptions = {
    url: `/api/v5/fields/owned?userId=${userId}`,
    userId,
    isPagedData: true
  };

  const graphRequest = {
    userId
  };

  return networkAdapter({
    legacyOptions,
    options: graphRequest
  });
};

export const fetchAllSharedFields = ({ userId }) => {
  const legacyOptions = {
    url: `/api/v5/fields/accessible`,
    userId,
    isPagedData: true
  };

  return networkAdapter({
    legacyOptions
  });
};

export const fetchOneField = ({ fieldId, userId, operationId }) => {
  const graphRequest = {
    userId,
    query: `
      query Field($fieldId: String!, $operationId: String!) {
        operation(id: $operationId) {
          field(id: $fieldId) {
            
          }
        }
      }
    `,
    variables: {
      fieldId,
      operationId
    }
  };

  return networkAdapter({
    options: graphRequest,
    useOL: true,
    transformResponse: (data) => {
      return data;
    }
  });
};

export const fetchFieldsByOperations = (operationsIds) => {
  const query = gql`
  query FieldsByOperations($ids: [ID!]) {
    operations(ids: $ids) {
      userId: legacyOwnerId 
      operationId: id
      operationName
      fields(first: 10000) {
        nodes {
          uuid: id
          id: legacyId
          name
          area {
            u: unit
            q: value
          }
          centroid {
            type
            coordinates
          }
          farm {
            name
            growerName
            id
          }
          countryCode
        }
      }
    }
  }`;

  const variables = { ids: operationsIds };

  try {
    return orchestrationLayerFetcher(query, variables);
  } catch(error) {
    trackError(new TypeError('Could not fetch "FieldsByOperations" query from OL'), { error, query, variables });
    throw error;
  }
};
